/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import React from 'react';

const IconChevronUp = ({ classNames }) => {
  const classes = `${classNames}`;
  return (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" className={classes}>
      <path
        d="M6 15L12 9L18 15"
        stroke="#344054"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

IconChevronUp.defaultProps = {
  classNames: '',
};

IconChevronUp.propTypes = {
  classNames: PropTypes.string,
};

export default IconChevronUp;
